// import styles from './app-description-sub-panel.module.scss';
import React from 'react';
import { Heading, Text, VStack } from 'native-base';

export interface AppDescriptionSubPanelProps {
  header: string;
  subheader: string;
  body: string;
}

function AppDescriptionSubPanel({
  header,
  subheader,
  body,
}: AppDescriptionSubPanelProps) {
  return (
    <VStack space={7} textAlign={{ base: 'center', md: 'left' }}>
      <Heading
        fontSize={{ base: '5xl', md: '4xl', lg: '5xl' }}
        lineHeight={50}
        color={'primary.400'}
      >
        {header}
      </Heading>
      {subheader && (
        <Heading
          fontSize={{ base: '2xl', md: '2xl', xl: '2xl' }}
          lineHeight={35}
          color={'white'}
        >
          {subheader}
        </Heading>
      )}
      <Text
        fontSize={{ base: '2xl', md: 'xl', xl: '2xl' }}
        lineHeight={35}
        color={'purple.300'}
      >
        {body}
      </Text>
    </VStack>
  );
}

const MemoAppDescriptionSubPanel = React.memo(AppDescriptionSubPanel);
export { MemoAppDescriptionSubPanel };
